<template>
  <md-dialog :md-active.sync="active" @md-closed="close">
    <md-dialog-title>エラーが発生しました！ （&gt; &lt;）</md-dialog-title>
    <md-dialog-content>
      <p>
        {{ err.appMessage }}
      </p>
      <pre>{{ err.stack }}</pre>
    </md-dialog-content>
    <md-dialog-actions>
      <div v-if="isReportActive" class="animated flash delay-1s" style="flex:1">
        <md-icon style="color:green">check_circle</md-icon
        >この事象は開発チームに送信されました。
      </div>
      <gl-button @click="close">Close</gl-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { Subject } from 'rxjs'

/**
 * 想定外エラーをユーザーに伝えるダイアログ
 */
export default {
  data() {
    const subject = new Subject()
    return {
      active: false,
      afterClosed: subject,
      afterClosed$: subject.asObservable(),
      err: {
        appMessage: undefined,
        stack: undefined,
      },
      /**
       * エラーレポート送信が有効になっているか
       */
      isReportActive: process.env.VUE_APP_SENTRY_DSN,
    }
  },
  methods: {
    open({ err /*, vm, info*/ }) {
      // TODO 本当はダイアログで使うものはpropsでもらいたい
      // TODO エラー情報に出すものを精査
      this.err.appMessage = err.appMessage || err.message
      this.err.stack = err.stack
      this.active = true

      return this.afterClosed$
    },
    close(arg = undefined) {
      this.active = false
      this.afterClosed.next(arg)
    },
  },
}
</script>

<style lang="scss" scoped>
.md-dialog-title {
  color: var(--color-warn);
}

pre {
  background-color: var(--bg-color-accent);
  color: #fff;
  overflow-x: auto;
  padding: var(--spacing-medium);
  min-width: 300px;
  max-width: 500px;
}
</style>
